<!-- The ref attr used to find the swiper instance -->
<template>
    <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <!-- <swiper-slide v-for="(product, index) in productList" :key="product.id">I'm Slide 1</swiper-slide> -->


        <swiper-slide v-for="(product, index) in excludedProductList" :key="product.id" :class="{'products__item--reversed': index % 2 !== 0}">
            <div class="card card--04">
                <router-link :to="{ name: 'productSingle', params: { productID: product.id,  }}" class="card__link">
                    <figure class="card__figure">
                        <img v-if="product.post_image" :src="product.post_image" alt="" class="rspimg">
                        <img v-else src="https://picsum.photos/535/301?image=1067" alt="" class="rspimg">
                    </figure>
                    <div class="card__data">
                        <h3 class="card__title">{{ product.title }}</h3>
                    </div>

                </router-link>
            </div>
        </swiper-slide>

        <!-- Optional controls -->
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->

        <div class="swiper-button-prev" slot="button-prev"><i class="icon-arrow-left"></i></div>
        <div class="swiper-button-next" slot="button-next"><i class="icon-arrow-right"></i></div>
        <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
    </swiper>
</template>

<script>
import axios from 'axios';
import { swiper, swiperSlide } from 'vue-awesome-swiper'

// require styles
import 'swiper/dist/css/swiper.css'

export default {
    name: 'carousel',
    components: {
      swiper,
      swiperSlide
    },
    props: [
        'productID',
        'msg',
        'product'
    ],
    data() {
        return {
            productList: [],
            swiperOption: {
                loop: true,
                direction: 'horizontal',
                slidesPerView: 1.3,
                centeredSlides: true,
                loopedSlides: 1,
                spaceBetween: 20,

                // Pagination
                pagination: {
                    clickable: true
                },

                // Arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                // Responsive breakpoints
                breakpointsInverse: true,
                breakpoints: {
                    // >= 768px
                    768: {
                      slidesPerView: 2.2,
                      centeredSlides: false,
                    },
                    // >= 980px
                    980: {
                      slidesPerView: 3.2,
                      centeredSlides: false,
                    }
                }
            }
        }
    },
    mounted() {
        // get post data
        this.getPosts();

        // current swiper instance
        // console.log('this is current swiper instance object', this.swiper)
        // this.swiper.slideTo(3, 1000, false)
    },
    update() {
        // get post data every time we change the route
        this.getPosts();
    },
    computed: {
        // Exclude current object from list and display only 10 entries
        excludedProductList() {
            const currentID = this.$route.params.productID
            return this.productList.slice(0, 20).filter(function(item) {
                return item.id != currentID
            })
        },

        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    methods: {
        getPosts() {
            const baseUrl = 'https://www.studenac.hr/api/recipes';
            const token = '?token=hHnqxgrqmTztC8SkjJqgOPk3jo8dLwp0';

            axios.get(baseUrl + token).then(response => {
               this.productList = response.data.recipes;
               // console.log(this.productList);
            }).catch(error => {
                console.log(error);
            })
        }
    } 
}
</script>